import isFunction from 'lodash/isFunction';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LensPackage } from '../meta/IBrain';
import { colorActions } from '../redux/slices/color';
import { insuranceActions } from '../redux/slices/insurance';
import { modalsActions } from '../redux/slices/modals';
import { prescriptionActions } from '../redux/slices/prescription';
import { workflowActions } from '../redux/slices/workflow';
import { getCheapPackageFromList } from '../utils/functions/prices';
import { configActions } from '../redux/slices/config';

export function useExternalListener() {
  const configAction = useSelector((state: any) => state.config?.actionsModule);
  const configInsurance = useSelector(
    (state: any) => state.config?.insuranceModule
  );
  const configData = useSelector((state: any) => state.config?.data);
  const frame = useSelector((state: any) => state.config?.data?.frame);
  const configPrescription = useSelector(
    (state: any) => state.config?.prescriptionModule
  );
  const loadPreselectEnabled = useSelector(
    (state: any) => state.workflow?.loadPreselect
  );
  const cartMode = useSelector((state: any) => state.config?.cartMode);
  //bundles
  const bundles = useSelector(
    (state: any) => state.config?.lensesData?.bundles
  );
  const bundlesPrices = useSelector(
    (state: any) => state.config?.lensesData?.bundlesPrices
  );
  //speedy
  const speedyIsActive = useSelector(
    (state: any) => state.layout?.speedyRX?.isSpeedyRXActive
  );

  const getBundleObject = useCallback(
    (selectedPkg: LensPackage) => {
      let bundleObject = null;
      const lensPackageUpc = selectedPkg?.lensPackage?.upc;
      if (window.rxcBrain.bundlesEnabled && lensPackageUpc) {
        const selectedBundle = bundles.find(
          (b) => b.lensPackageUPC === lensPackageUpc
        );
        const selectedBundlePrices = bundlesPrices.find(
          (b) => b.bundleUPC === selectedBundle?.bundleUPC
        );
        if (selectedBundle && selectedBundlePrices) {
          bundleObject = {
            ...selectedBundle,
            ...selectedBundlePrices,
          };
        }
      }
      return bundleObject;
    },
    [window.rxcBrain.bundlesEnabled, bundles, bundlesPrices]
  );

  const dispatch = useDispatch();

  const onLoadPrescription = () => {
    const validateFullPrescriptionObject = (prescriptionObject) => {
      if (prescriptionObject) {
        if (
          prescriptionObject.SPH !== undefined &&
          prescriptionObject.SPH !== null &&
          prescriptionObject.SPH.OD !== undefined &&
          prescriptionObject.SPH.OD !== null &&
          !isNaN(prescriptionObject.SPH.OD) &&
          prescriptionObject.SPH.OS !== undefined &&
          prescriptionObject.SPH.OS !== null &&
          !isNaN(prescriptionObject.SPH.OS)
        ) {
          const CYLCheck =
            !prescriptionObject.CYL ||
            (prescriptionObject.CYL !== undefined &&
              prescriptionObject.CYL !== null &&
              ((prescriptionObject.CYL.OD !== undefined &&
                prescriptionObject.CYL.OD !== null &&
                !isNaN(prescriptionObject.CYL.OD)) ||
                (prescriptionObject.CYL.OS !== undefined &&
                  prescriptionObject.CYL.OS !== null &&
                  !isNaN(prescriptionObject.CYL.OS))));
          const AXCheck =
            !prescriptionObject.AX ||
            (prescriptionObject.AX !== undefined &&
              prescriptionObject.AX !== null &&
              ((prescriptionObject.AX.OD !== undefined &&
                prescriptionObject.AX.OD !== null &&
                !isNaN(prescriptionObject.AX.OD)) ||
                (prescriptionObject.AX.OS !== undefined &&
                  prescriptionObject.AX.OS !== null &&
                  !isNaN(prescriptionObject.AX.OS))));
          const ADDCheck =
            !prescriptionObject.ADD ||
            (prescriptionObject.ADD !== undefined &&
              prescriptionObject.ADD !== null &&
              ((prescriptionObject.ADD.OD !== undefined &&
                prescriptionObject.ADD.OD !== null &&
                !isNaN(prescriptionObject.ADD.OD)) ||
                (prescriptionObject.ADD.OS !== undefined &&
                  prescriptionObject.ADD.OS !== null &&
                  !isNaN(prescriptionObject.ADD.OS))));
          const PDCheck =
            !prescriptionObject.PD ||
            (prescriptionObject.PD !== undefined &&
              prescriptionObject.PD !== null &&
              prescriptionObject.PD.OD !== undefined &&
              prescriptionObject.PD.OD !== null &&
              !isNaN(prescriptionObject.PD.OD));
          return CYLCheck && AXCheck && ADDCheck && PDCheck;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };

    const checkAndSetEditFromCart = () => {
      console.log(
        'checkAndSetEditFromCart configData?.lens?.catEntryId',
        configData?.lens?.catEntryId
      );
      if (configData?.lens?.catEntryId) {
        dispatch(workflowActions.enablePreselect(true));
        //dispatch(workflowActions.forceEnablePreselectSpinner(true));
      } else {
        dispatch(workflowActions.enablePreselect(false));
        //dispatch(workflowActions.forceEnablePreselectSpinner(false));
      }
    };

    console.log(
      'checkAndSetEditFromCart loadExtendedPrescription value',
      configPrescription?.loadExtendedPrescription
    );

    if (configPrescription?.loadExtendedPrescription) {
      console.log('checkAndSetEditFromCart loadExtendedPrescription');
      const errorMessage = 'ERROR while retrieving prescription data';

      let requestObject = { data: { lens: null } };
      if (configData?.lens) {
        requestObject.data.lens = configData.lens;
      }

      configPrescription
        .loadExtendedPrescription(requestObject)
        .then((response) => {
          console.log(
            'loadExtendedPrescription response',
            response,
            loadPreselectEnabled
          );
          if (!response) {
            throw new Error(errorMessage);
          }
          if (response.prescriptionFlow === 'MANUAL') {
            if (validateFullPrescriptionObject(response)) {
              //ok
              let prescriptionFromCart = response;
              // COntrollo se c'è almeno un valore prism e setto il prism enabled
              if (
                response?.HBASEDIR?.OS ||
                response?.HBASEDIR?.OD ||
                response?.HPRISM?.OS ||
                response?.HPRISM?.OD ||
                response?.VBASEDIR?.OS ||
                response?.VBASEDIR?.OD ||
                response?.VPRISM?.OS ||
                response?.VPRISM?.OD
              ) {
                prescriptionFromCart = {
                  ...prescriptionFromCart,
                  PRISM_ENABLED: true,
                };
              }

              dispatch(
                prescriptionActions.setCurrentPrescription(prescriptionFromCart)
              );

              if (
                !loadPreselectEnabled &&
                response.prescriptionFlow &&
                response.prescriptionFlow !== ''
              ) {
                dispatch(
                  prescriptionActions.setCurrentPrescription(
                    prescriptionFromCart
                  )
                );
                if (!cartMode) {
                  dispatch(prescriptionActions.setLoadedWithoutEdit(true));
                }
              }
            } else {
              //error
              throw new Error(errorMessage);
            }
          } else {
            dispatch(prescriptionActions.setCurrentPrescription(response));
          }
        })
        .catch((ex) => {
          console.error(errorMessage);
        })
        .finally(() => {
          checkAndSetEditFromCart();
          window.rxcBrain.setIsWaitingForPrescription(false);
        });
    } else {
      console.log('checkAndSetEditFromCart');
      checkAndSetEditFromCart();
      window.rxcBrain.setIsWaitingForPrescription(false);
    }
  };

  const onAddToCart = (evt) => {
    try {
      //@ts-ignore
      let products = utag_data.Products;

      if (products) {
        Object.values(products).forEach((product) => {
          const isSpeedyActive =
            window.rxcBrain?.speedyRxModule?.isActive() && speedyIsActive;
          if (isSpeedyActive) {
            product.SpeedyRx_Badge = 'Y';
          } else {
            product.SpeedyRx_Badge = '';
          }
        });
      }

      //@ts-ignore
      tealium_data2track.push({
        id: 'Event',
        Events_CartAdd: '1',
        Products: products,
      });
    } catch (error) {
      console.log(
        'Error during tealium_data2track push. Check if tealium_data2track exists in the window.'
      );
    }
    if (configAction) {
      let selectedPackage;
      let sendingFrame;
      const selectedFrameColor = window.rxcBrain.selectedFrameColor;
      if (
        window?.rxcBrain?.currentStep?.key === 'MixAndMatch' &&
        window.rxcBrain.superNovaCurrentFilteredPackages?.length > 0
      ) {
        selectedPackage = getCheapPackageFromList(
          window.rxcBrain.superNovaCurrentFilteredPackages
        );
        if (selectedFrameColor) {
          sendingFrame = selectedFrameColor;
        } else {
          sendingFrame = frame;
        }
      } else {
        selectedPackage = getCheapPackageFromList(
          window.rxcBrain.currentPackages
        );
        sendingFrame = frame;
      }

      const bundleObject = getBundleObject(selectedPackage);

      const _config = {
        //content: window.rxcBrain.content,
        //packages: window.rxcBrain.initialLensPackages,
        brand: window.rxcBrain.config?.brand,
        baseURLs: window.rxcBrain.config?.baseURLs,
        frame: window.rxcBrain.config?.data?.frame,
      };

      console.log(
        'selected package + bundleObj + _config: ',
        selectedPackage,
        bundleObject,
        _config
      );
      configAction.genericAddToCart(
        sendingFrame,
        selectedPackage,
        evt.detail.selectedWarranty,
        evt.detail.reviewObjectForCart,
        evt.detail.imagery,
        _config,
        bundleObject
      );
    }
  };

  const onEditCart = (evt) => {
    try {
      //@ts-ignore
      let products = utag_data.Products;

      if (products) {
        Object.values(products).forEach((product) => {
          const isSpeedyActive =
            window.rxcBrain?.speedyRxModule?.isActive() && speedyIsActive;
          if (isSpeedyActive) {
            product.SpeedyRx_Badge = 'Y';
          } else {
            product.SpeedyRx_Badge = '';
          }
        });
      }

      //@ts-ignore
      tealium_data2track.push({
        id: 'Event',
        Events_CartAdd: '1',
        Products: products,
      });
    } catch (error) {
      console.log(
        'Error during tealium_data2track push. Check if tealium_data2track exists in the window.'
      );
    }
    if (configAction) {
      const selectedPackage = getCheapPackageFromList(
        window.rxcBrain.currentPackages
      );
      const bundleObject = getBundleObject(selectedPackage);

      const _config = {
        //content: window.rxcBrain.content,
        //packages: window.rxcBrain.initialLensPackages,
        brand: window.rxcBrain.config?.brand,
        baseURLs: window.rxcBrain.config?.baseURLs,
        frame: window.rxcBrain.config?.data?.frame,
      };

      console.log(
        'selected package + bundleObj + _config: ',
        selectedPackage,
        bundleObject,
        _config
      );
      configAction.genericSaveEditFromCart(
        frame,
        selectedPackage,
        evt.detail.selectedWarranty,
        cartMode,
        evt.detail.reviewObjectForCart,
        evt.detail.imagery,
        _config,
        bundleObject
      );
    }
  };

  const onBackToPdp = () => {
    if (isFunction(configAction.genericExit)) {
      configAction.genericExit();
    }
    window.RXC.rxcWidget.close();
    resetRedux();
  };

  const resetRedux = () => {
    dispatch(colorActions.reset());
    dispatch(configActions.reset());
    dispatch(insuranceActions.reset());
    dispatch(modalsActions.reset());
    dispatch(prescriptionActions.reset());
    dispatch(workflowActions.reset());
    window.rxcBrain.cleanStepChain();
    window.rxcBrain.cleanAllStepChain();
  };

  useEffect(() => {
    window.addEventListener('AddToCartEvent', onAddToCart);
    window.addEventListener('EditCartEvent', onEditCart);
    window.addEventListener('BackToPdp', onBackToPdp);
    window.addEventListener('LoadPrescription', onLoadPrescription);
    //   window.addEventListener("SaveAndExit", onSaveAndExit);
    (window as any).RXC.rxcWidget['listeners'] = {
      AddToCartEvent: onAddToCart,
      BackToPdp: onBackToPdp,
      LoadPrescription: onLoadPrescription,
      //SaveAndExit: onSaveAndExit,
    };

    return () => {
      window.removeEventListener('AddToCartEvent', onAddToCart);
      window.removeEventListener('EditCartEvent', onEditCart);
      window.removeEventListener('BackToPdp', onBackToPdp);
      window.removeEventListener('LoadPrescription', onLoadPrescription);
      //   window.removeEventListener("SaveAndExit", onSaveAndExit);
    };
  }, [configAction, frame]);

  // insurance

  const onInsuranceEnabled = () => {
    dispatch(insuranceActions.setInsuranceEnabled(true));
  };

  const onInsuranceDisabled = () => {
    dispatch(insuranceActions.setInsuranceEnabled(false));
  };

  const onInsuranceLogin = () => {
    dispatch(insuranceActions.setInsuranceEnabled(true));
  };

  const onInsuranceLogout = () => {
    dispatch(insuranceActions.setInsuranceEnabled(false));
  };

  useEffect(() => {
    if (configInsurance) {
      window.addEventListener(
        configInsurance.getEvents().INSURANCE_ENABLED,
        onInsuranceEnabled
      );
      window.addEventListener(
        configInsurance.getEvents().INSURANCE_DISABLED,
        onInsuranceDisabled
      );
      window.addEventListener(
        configInsurance.getEvents().INSURANCE_LOGIN,
        onInsuranceLogin
      );
      window.addEventListener(
        configInsurance.getEvents().INSURANCE_LOGOUT,
        onInsuranceLogout
      );

      if (configInsurance.isEnabled()) {
        window.dispatchEvent(
          new CustomEvent(configInsurance.getEvents().INSURANCE_ENABLED)
        );
      }
    }

    return () => {
      if (configInsurance) {
        window.removeEventListener(
          configInsurance.getEvents().INSURANCE_ENABLED,
          onInsuranceEnabled
        );
        window.removeEventListener(
          configInsurance.getEvents().INSURANCE_DISABLED,
          onInsuranceDisabled
        );
        window.removeEventListener(
          configInsurance.getEvents().INSURANCE_LOGIN,
          onInsuranceLogin
        );
        window.removeEventListener(
          configInsurance.getEvents().INSURANCE_LOGOUT,
          onInsuranceLogout
        );
      }
    };
  }, [configInsurance]);
}
